import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  class: "mt-5 pt-5 ps-3",
  "aria-label": "breadcrumb"
}
const _hoisted_2 = { class: "breadcrumb mb-3" }
const _hoisted_3 = { class: "breadcrumb-item" }
const _hoisted_4 = { class: "container-fluid" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-sm-12" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table table-hover" }
const _hoisted_11 = { class: "table-dark" }
const _hoisted_12 = { class: "no-select" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  colspan: 9,
  class: "text-center py-4"
}
const _hoisted_16 = { class: "text-center py-5" }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = {
  colspan: 9,
  class: "text-center py-5"
}
const _hoisted_19 = { class: "alert alert-danger" }
const _hoisted_20 = { key: 3 }
const _hoisted_21 = ["src", "alt"]
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = { class: "fw-semibold" }
const _hoisted_24 = { class: "text-muted" }
const _hoisted_25 = ["onClick", "title"]
const _hoisted_26 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_27 = ["onClick", "title"]
const _hoisted_28 = { class: "fw-semibold text-info" }
const _hoisted_29 = { class: "form-check form-switch" }
const _hoisted_30 = ["checked", "onChange"]
const _hoisted_31 = ["onClick", "disabled", "title"]
const _hoisted_32 = {
  key: 0,
  class: "card-footer bg-light"
}
const _hoisted_33 = { class: "row text-center" }
const _hoisted_34 = { class: "col-md-3" }
const _hoisted_35 = { class: "d-flex flex-column" }
const _hoisted_36 = { class: "h4 mb-0 text-primary" }
const _hoisted_37 = { class: "col-md-3" }
const _hoisted_38 = { class: "d-flex flex-column" }
const _hoisted_39 = { class: "h4 mb-0 text-success" }
const _hoisted_40 = { class: "col-md-3" }
const _hoisted_41 = { class: "d-flex flex-column" }
const _hoisted_42 = { class: "h4 mb-0 text-warning" }
const _hoisted_43 = { class: "col-md-3" }
const _hoisted_44 = { class: "d-flex flex-column" }
const _hoisted_45 = { class: "h4 mb-0 text-info" }
const _hoisted_46 = {
  key: 0,
  class: "d-flex justify-content-end align-items-center gap-3 mt-3 mb-4 flex-wrap px-3"
}
const _hoisted_47 = { class: "d-flex align-items-center gap-2" }
const _hoisted_48 = ["value"]
const _hoisted_49 = { class: "pagination-mini" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = ["disabled", "onClick"]
const _hoisted_52 = ["disabled"]
const _hoisted_53 = { class: "modal-dialog modal-lg" }
const _hoisted_54 = { class: "modal-content" }
const _hoisted_55 = { class: "modal-header" }
const _hoisted_56 = { class: "modal-title" }
const _hoisted_57 = { class: "modal-body" }
const _hoisted_58 = { class: "row" }
const _hoisted_59 = { class: "col-md-4 text-center" }
const _hoisted_60 = ["src", "alt"]
const _hoisted_61 = ["src", "alt"]
const _hoisted_62 = { class: "text-muted small" }
const _hoisted_63 = { class: "col-md-8" }
const _hoisted_64 = { class: "row g-3" }
const _hoisted_65 = { class: "col-md-6" }
const _hoisted_66 = { class: "card h-100" }
const _hoisted_67 = { class: "card-body text-center" }
const _hoisted_68 = { class: "badge bg-primary fs-6" }
const _hoisted_69 = { class: "col-md-6" }
const _hoisted_70 = { class: "card h-100" }
const _hoisted_71 = { class: "card-body text-center" }
const _hoisted_72 = { class: "text-primary mb-0" }
const _hoisted_73 = { class: "col-md-6" }
const _hoisted_74 = { class: "card h-100" }
const _hoisted_75 = { class: "card-body text-center" }
const _hoisted_76 = { class: "text-success mb-0" }
const _hoisted_77 = { class: "col-md-6" }
const _hoisted_78 = { class: "card h-100" }
const _hoisted_79 = { class: "card-body text-center" }
const _hoisted_80 = { class: "text-info mb-0" }
const _hoisted_81 = { class: "col-md-6" }
const _hoisted_82 = { class: "card h-100" }
const _hoisted_83 = { class: "card-body text-center" }
const _hoisted_84 = { class: "text-secondary mb-0" }
const _hoisted_85 = { class: "text-muted" }
const _hoisted_86 = { class: "col-md-6" }
const _hoisted_87 = { class: "card h-100" }
const _hoisted_88 = { class: "card-body text-center" }
const _hoisted_89 = { class: "text-warning mb-0" }
const _hoisted_90 = { class: "col-md-6" }
const _hoisted_91 = { class: "card h-100" }
const _hoisted_92 = { class: "card-body text-center" }
const _hoisted_93 = { class: "text-danger mb-0" }
const _hoisted_94 = { class: "col-md-6" }
const _hoisted_95 = { class: "card h-100" }
const _hoisted_96 = { class: "card-body text-center" }
const _hoisted_97 = { class: "text-primary mb-0" }
const _hoisted_98 = { class: "col-md-6" }
const _hoisted_99 = { class: "card h-100" }
const _hoisted_100 = { class: "card-body text-center" }
const _hoisted_101 = { class: "form-check form-switch d-flex justify-content-center" }
const _hoisted_102 = {
  class: "form-check-label",
  for: "modalInternalSwitch"
}

import { ref, computed, onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import apiService from "@/services/apiService";
import { usePermissions } from "@/composables/usePermissions";

interface User {
  _id: string;
  username: string;
  logo: string | null;
  registered_at: string;
  no_workspaces: number;
  subscription_plan: string;
  workspaces_created: number;
  team_members: number;
  cards_created: number;
  cards_this_month: number;
  sprints_created: number;
  sprints_active: number;
  api_requests_used: number;
  storage_used_mb: number;
  storage_total_mb: string;
  lane_variables: number;
  card_variables: number;
  is_internal?: boolean;
}

// Reactive data

export default /*@__PURE__*/_defineComponent({
  __name: 'RegisteredUsers',
  setup(__props) {

const { canView } = usePermissions();

// Router
const router = useRouter();

// Types
const users = ref<User[]>([]);
const isLoading = ref(false);
const error = ref<string | null>(null);
const selectedUser = ref<User | null>(null);
const showUserDetailsModal = ref(false);
const sortBy = ref<string | null>(null);
const sortOrder = ref<'asc' | 'desc'>('asc');

const isServerPaginated = ref(false);

// --- Pagination State ---
const tablePagination = ref({
  current_page: 1,
  per_page: 10,
  total: 0,
  total_pages: 0,
  has_next: false,
  has_prev: false,
});

const visiblePages = computed(() => {
  const total = tablePagination.value.total_pages;
  const current = tablePagination.value.current_page;

  if (!total || total <= 4) {
    return Array.from({ length: Math.max(1, total) }, (_, i) => i + 1);
  }

  const pages: (number | string)[] = [];
  pages.push(1);

  if (current > 4) pages.push("...");

  const windowStart = Math.max(2, current - 1);
  const windowEnd = Math.min(total - 1, current + 1);
  for (let i = windowStart; i <= windowEnd; i++) pages.push(i);

  if (current < total - 3) pages.push("...");

  pages.push(total);
  return pages;
});

const totalUsers = computed(() => tablePagination.value.total || users.value.length);

const sortedUsers = computed(() => {
  if (!sortBy.value || users.value.length === 0) return users.value;
  
  console.log(`Sorting by ${sortBy.value} (${sortOrder.value})`);
  
  return [...users.value].sort((a, b) => {
    let valA = (a as any)[sortBy.value!];
    let valB = (b as any)[sortBy.value!];
    
    // Date handling
    if (sortBy.value === 'registered_at') {
      const dateA = new Date(valA).getTime();
      const dateB = new Date(valB).getTime();
      return sortOrder.value === 'asc' ? dateA - dateB : dateB - dateA;
    }
    
    // Handle null/undefined/empty
    if (valA === null || valA === undefined) valA = '';
    if (valB === null || valB === undefined) valB = '';
    
    // String comparison
    if (typeof valA === 'string' && typeof valB === 'string') {
      const cmp = valA.toLowerCase().localeCompare(valB.toLowerCase());
      return sortOrder.value === 'asc' ? cmp : -cmp;
    }
    
    // Numeric comparison
    const numA = Number(valA);
    const numB = Number(valB);
    
    if (!isNaN(numA) && !isNaN(numB)) {
      return sortOrder.value === 'asc' ? numA - numB : numB - numA;
    }
    
    // Fallback
    return 0;
  });
});

const paginatedUsers = computed(() => {
  const data = sortedUsers.value;
  if (isServerPaginated.value) {
    return data;
  }
  const start = (tablePagination.value.current_page - 1) * tablePagination.value.per_page;
  const end = start + tablePagination.value.per_page;
  return data.slice(start, end);
});

// Computed properties
const usersWithWorkspaces = computed(
  () => users.value.filter((user) => user.no_workspaces > 0).length
);

const totalWorkspaces = computed(() =>
  users.value.reduce((sum, user) => sum + user.no_workspaces, 0)
);

const averageWorkspaces = computed(() =>
  users.value.length > 0 ? totalWorkspaces.value / users.value.length : 0
);

// Methods
const loadUsers = async (page = 1, limit = 10) => {
  isLoading.value = true;
  error.value = null;

  try {
    console.log("Loading registered users...");
    const response = await apiService.get("/common/cms/users", { 
      page, 
      limit,
      sort_by: sortBy.value,
      sort_order: sortOrder.value,
      sortBy: sortBy.value,
      sortOrder: sortOrder.value
    });

    console.log("API Response:", response);

    // Handle different response structures
    if (Array.isArray(response)) {
      // Direct array response (non-paginated)
      users.value = response;
      isServerPaginated.value = false;
      tablePagination.value.current_page = 1;
      tablePagination.value.total_pages = 1;
      tablePagination.value.total = response.length;
      tablePagination.value.has_prev = false;
      tablePagination.value.has_next = false;
      console.log(`Loaded ${users.value.length} users`);
    } else if (Array.isArray(response.data)) {
      // Paginated response with data property
      users.value = response.data;
      isServerPaginated.value = !!response.pagination;
      
      if (response.pagination) {
        tablePagination.value.current_page = response.pagination.current_page || page;
        tablePagination.value.total_pages = response.pagination.total_pages || 1;
        tablePagination.value.total = response.pagination.total || response.data.length;
        tablePagination.value.has_prev = (response.pagination.current_page || page) > 1;
        tablePagination.value.has_next =
          (response.pagination.current_page || page) < (response.pagination.total_pages || 1);
      } else {
        // Fallback if no pagination metadata
        tablePagination.value.current_page = page;
        tablePagination.value.total_pages = 1;
        tablePagination.value.total = response.data.length;
        tablePagination.value.has_prev = false;
        tablePagination.value.has_next = false;
      }
      console.log(`Loaded ${users.value.length} users`);
    } else {
      console.error("Invalid response structure:", response);
      throw new Error(
        `Invalid response format. Expected array, got: ${typeof response}`
      );
    }
  } catch (err: any) {
    console.error("Error loading users:", err);
    error.value =
      err?.response?.data?.message || err?.message || "Failed to load users";
    users.value = [];
  } finally {
    isLoading.value = false;
  }
};

const changeRows = async () => {
  tablePagination.value.current_page = 1;
  await loadUsers(1, tablePagination.value.per_page);
};

const handlePageChange = async (page: number) => {
  if (typeof page !== "number" || Number.isNaN(page)) return;
  if (page < 1 || page === tablePagination.value.current_page) return;
  if (tablePagination.value.total_pages && page > tablePagination.value.total_pages) {
    return;
  }
  await loadUsers(page, tablePagination.value.per_page);
};

const getInitials = (name: string): string => {
  return name
    .split(" ")
    .map((word) => word.charAt(0))
    .join("")
    .toUpperCase()
    .slice(0, 2);
};

const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

const formatTimeAgo = (dateString: string): string => {
  const date = new Date(dateString);
  const now = new Date();
  const diffInMs = now.getTime() - date.getTime();
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  if (diffInDays === 0) {
    return "Today";
  } else if (diffInDays === 1) {
    return "Yesterday";
  } else if (diffInDays < 7) {
    return `${diffInDays} days ago`;
  } else if (diffInDays < 30) {
    const weeks = Math.floor(diffInDays / 7);
    return `${weeks} week${weeks > 1 ? "s" : ""} ago`;
  } else if (diffInDays < 365) {
    const months = Math.floor(diffInDays / 30);
    return `${months} month${months > 1 ? "s" : ""} ago`;
  } else {
    const years = Math.floor(diffInDays / 365);
    return `${years} year${years > 1 ? "s" : ""} ago`;
  }
};

// Navigation function for workspaces
const navigateToWorkspaces = (userId: string) => {
  console.log("Navigating to workspaces for user:", userId);
  router.push({ path: `/user-workspaces/${userId}` });
};

// Modal functions
const openUserDetailsModal = (user: User) => {
  selectedUser.value = user;
  showUserDetailsModal.value = true;
};

const closeUserDetailsModal = () => {
  showUserDetailsModal.value = false;
  selectedUser.value = null;
};

const handleSort = (field: string) => {
  console.log('handleSort clicked for field:', field);
  if (sortBy.value === field) {
    sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc';
  } else {
    sortBy.value = field;
    sortOrder.value = 'asc';
  }
};

// Watch for sort changes to reload from server
watch([sortBy, sortOrder], () => {
  loadUsers(tablePagination.value.current_page, tablePagination.value.per_page);
});

const handleToggleInternal = async (user: User) => {
  if (!user || !user._id) return;
  
  try {
    await apiService.toggleUserInternal(user._id);
    user.is_internal = !user.is_internal;
    // Note: We don't need to refresh the whole table here since we're updating the local object reference
  } catch (err: any) {
    console.error("Error toggling user internal status:", err);
    // Revert local state on error
    user.is_internal = !user.is_internal;
  }
};

// Lifecycle
onMounted(() => {
  loadUsers(tablePagination.value.current_page, tablePagination.value.per_page);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("ol", _hoisted_2, [
        _createElementVNode("li", _hoisted_3, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
              _createTextVNode("Home", -1)
            ]))]),
            _: 1
          })
        ]),
        _cache[14] || (_cache[14] = _createElementVNode("li", {
          class: "breadcrumb-item active",
          "aria-current": "page"
        }, " Registered Users ", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[31] || (_cache[31] = _createElementVNode("div", { class: "card-header" }, [
              _createElementVNode("h5", null, "Registered Users")
            ], -1)),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("table", _hoisted_10, [
                  _createElementVNode("thead", _hoisted_11, [
                    _createElementVNode("tr", _hoisted_12, [
                      _cache[15] || (_cache[15] = _createElementVNode("th", null, "Avatar", -1)),
                      _createElementVNode("th", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (handleSort('username'))),
                        style: {"cursor":"pointer"}
                      }, "Username"),
                      _createElementVNode("th", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (handleSort('registered_at'))),
                        style: {"cursor":"pointer"}
                      }, "Registered Date"),
                      _createElementVNode("th", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (handleSort('registered_at'))),
                        style: {"cursor":"pointer"}
                      }, "Time Ago"),
                      _createElementVNode("th", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (handleSort('subscription_plan'))),
                        style: {"cursor":"pointer"}
                      }, "Subscription Plan"),
                      _createElementVNode("th", {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (handleSort('no_workspaces'))),
                        style: {"cursor":"pointer"}
                      }, "Workspaces"),
                      _createElementVNode("th", {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (handleSort('api_requests_used'))),
                        style: {"cursor":"pointer"}
                      }, "Tokens Used"),
                      _cache[16] || (_cache[16] = _createElementVNode("th", null, "Is Internal", -1)),
                      _cache[17] || (_cache[17] = _createElementVNode("th", null, "Actions", -1))
                    ])
                  ]),
                  (isLoading.value)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_13, [...(_cache[18] || (_cache[18] = [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", {
                            colspan: 9,
                            class: "text-center py-4"
                          }, [
                            _createElementVNode("div", {
                              class: "spinner-border text-primary",
                              role: "status"
                            }, [
                              _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                            ])
                          ])
                        ], -1)
                      ]))]))
                    : (users.value.length < 1)
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_14, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_15, [
                              _createElementVNode("div", _hoisted_16, [
                                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "mb-3" }, [
                                  _createElementVNode("i", { class: "fa fa-users fa-3x text-muted" })
                                ], -1)),
                                _cache[21] || (_cache[21] = _createElementVNode("h5", { class: "text-muted" }, "No Users Found", -1)),
                                _cache[22] || (_cache[22] = _createElementVNode("p", { class: "text-muted" }, " There are no registered users to display. ", -1)),
                                _createElementVNode("button", {
                                  class: "btn btn-primary",
                                  onClick: _cache[6] || (_cache[6] = () => loadUsers())
                                }, [...(_cache[19] || (_cache[19] = [
                                  _createElementVNode("i", { class: "fa fa-refresh me-1" }, null, -1),
                                  _createTextVNode(" Refresh ", -1)
                                ]))])
                              ])
                            ])
                          ])
                        ]))
                      : (error.value)
                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_17, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                  _cache[24] || (_cache[24] = _createElementVNode("i", { class: "fa fa-exclamation-triangle" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(error.value) + " ", 1),
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-outline-danger ms-2",
                                    onClick: _cache[7] || (_cache[7] = () => loadUsers())
                                  }, [...(_cache[23] || (_cache[23] = [
                                    _createElementVNode("i", { class: "fa fa-refresh" }, null, -1),
                                    _createTextVNode(" Retry ", -1)
                                  ]))])
                                ])
                              ])
                            ])
                          ]))
                        : (users.value.length>0)
                          ? (_openBlock(), _createElementBlock("tbody", _hoisted_20, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedUsers.value, (user) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: user._id
                                }, [
                                  _createElementVNode("td", null, [
                                    (user.logo)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: user.logo,
                                          alt: user.username,
                                          class: "rounded-circle",
                                          style: {"width":"40px","height":"40px","object-fit":"cover"}
                                        }, null, 8, _hoisted_21))
                                      : (_openBlock(), _createElementBlock("img", {
                                          key: 1,
                                          src: `https://ui-avatars.com/api/?name=${encodeURIComponent(
                            user.username
                          )}&background=007bff&color=fff&size=40`,
                                          alt: user.username,
                                          class: "rounded-circle",
                                          style: {"width":"40px","height":"40px"}
                                        }, null, 8, _hoisted_22))
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("div", _hoisted_23, _toDisplayString(user.username), 1)
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("div", null, _toDisplayString(formatDate(user.registered_at)), 1)
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("small", _hoisted_24, _toDisplayString(formatTimeAgo(user.registered_at)), 1)
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("button", {
                                      class: "badge bg-primary border-0",
                                      style: _normalizeStyle({ cursor: _unref(canView)('subscriptions') ? 'pointer' : 'not-allowed', pointerEvents: _unref(canView)('subscriptions') ? 'auto' : 'none' }),
                                      onClick: ($event: any) => (_unref(canView)('subscriptions') && openUserDetailsModal(user)),
                                      title: _unref(canView)('subscriptions') ? `View ${user.username}'s subscription details` : 'No permission to view'
                                    }, _toDisplayString(user.subscription_plan), 13, _hoisted_25)
                                  ]),
                                  _createElementVNode("td", null, [
                                    (user.no_workspaces === 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, " No workspaces "))
                                      : (_openBlock(), _createElementBlock("a", {
                                          key: 1,
                                          href: "#",
                                          onClick: _withModifiers(($event: any) => (navigateToWorkspaces(user._id)), ["prevent"]),
                                          class: "text-primary fw-semibold text-decoration-none",
                                          style: {"cursor":"pointer"},
                                          title: `View ${user.username}'s workspaces`
                                        }, [
                                          _cache[25] || (_cache[25] = _createElementVNode("i", { class: "fa fa-briefcase me-1" }, null, -1)),
                                          _createTextVNode(" " + _toDisplayString(user.no_workspaces) + " workspace" + _toDisplayString(user.no_workspaces > 1 ? "s" : ""), 1)
                                        ], 8, _hoisted_27))
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("div", _hoisted_28, _toDisplayString(user.api_requests_used.toLocaleString()), 1)
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("div", _hoisted_29, [
                                      _createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        role: "switch",
                                        checked: user.is_internal,
                                        onChange: ($event: any) => (handleToggleInternal(user)),
                                        style: {"cursor":"pointer"}
                                      }, null, 40, _hoisted_30)
                                    ])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("button", {
                                      class: "btn btn-sm btn-outline-info",
                                      onClick: ($event: any) => (_unref(canView)('subscriptions') && openUserDetailsModal(user)),
                                      disabled: !_unref(canView)('subscriptions'),
                                      title: _unref(canView)('subscriptions') ? 'View Details' : 'No permission'
                                    }, [...(_cache[26] || (_cache[26] = [
                                      _createElementVNode("i", { class: "fa fa-eye" }, null, -1)
                                    ]))], 8, _hoisted_31)
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                ])
              ])
            ]),
            (users.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("span", _hoisted_36, _toDisplayString(totalUsers.value), 1),
                        _cache[27] || (_cache[27] = _createElementVNode("small", { class: "text-muted" }, "Total Users", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("span", _hoisted_39, _toDisplayString(usersWithWorkspaces.value), 1),
                        _cache[28] || (_cache[28] = _createElementVNode("small", { class: "text-muted" }, "With Workspaces", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("span", _hoisted_42, _toDisplayString(totalWorkspaces.value), 1),
                        _cache[29] || (_cache[29] = _createElementVNode("small", { class: "text-muted" }, "Total Workspaces", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("span", _hoisted_45, _toDisplayString(Math.round(averageWorkspaces.value * 10) / 10), 1),
                        _cache[30] || (_cache[30] = _createElementVNode("small", { class: "text-muted" }, "Avg per User", -1))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (users.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _cache[32] || (_cache[32] = _createElementVNode("span", { class: "text-muted" }, "Rows per page:", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm rows-select",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((tablePagination.value.per_page) = $event)),
              onChange: changeRows
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([5, 10, 20, 50, 100], (n) => {
                return _createElementVNode("option", {
                  key: n,
                  value: n
                }, _toDisplayString(n), 9, _hoisted_48)
              }), 64))
            ], 544), [
              [
                _vModelSelect,
                tablePagination.value.per_page,
                void 0,
                { number: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("button", {
              class: "page-btn prev_btn",
              disabled: !tablePagination.value.has_prev,
              onClick: _cache[9] || (_cache[9] = ($event: any) => (handlePageChange(tablePagination.value.current_page - 1)))
            }, " « ", 8, _hoisted_50),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (p, index) => {
              return (_openBlock(), _createElementBlock("button", {
                key: index,
                class: _normalizeClass(["page-btn", {
            'page-active': p === tablePagination.value.current_page,
            'disabled-dots': p === '...',
          }]),
                disabled: p === '...',
                onClick: ($event: any) => (typeof p === 'number' && handlePageChange(p))
              }, _toDisplayString(p), 11, _hoisted_51))
            }), 128)),
            _createElementVNode("button", {
              class: "page-btn next_btn",
              disabled: !tablePagination.value.has_next,
              onClick: _cache[10] || (_cache[10] = ($event: any) => (handlePageChange(tablePagination.value.current_page + 1)))
            }, " » ", 8, _hoisted_52)
          ])
        ]))
      : _createCommentVNode("", true),
    (showUserDetailsModal.value && selectedUser.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "modal fade show d-block",
          style: {"background-color":"rgba(0, 0, 0, 0.5)"},
          onClick: _withModifiers(closeUserDetailsModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("h5", _hoisted_56, [
                  _cache[33] || (_cache[33] = _createElementVNode("i", { class: "fa fa-user me-2" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(selectedUser.value.username) + " - Subscription Details ", 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: closeUserDetailsModal
                })
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    (selectedUser.value.logo)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: selectedUser.value.logo,
                          alt: selectedUser.value.username,
                          class: "rounded-circle mb-3",
                          style: {"width":"80px","height":"80px","object-fit":"cover"}
                        }, null, 8, _hoisted_60))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: `https://ui-avatars.com/api/?name=${encodeURIComponent(
                    selectedUser.value.username
                  )}&background=007bff&color=fff&size=80`,
                          alt: selectedUser.value.username,
                          class: "rounded-circle mb-3",
                          style: {"width":"80px","height":"80px"}
                        }, null, 8, _hoisted_61)),
                    _createElementVNode("h6", null, _toDisplayString(selectedUser.value.username), 1),
                    _createElementVNode("p", _hoisted_62, " Registered: " + _toDisplayString(formatDate(selectedUser.value.registered_at)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, [
                            _cache[34] || (_cache[34] = _createElementVNode("i", { class: "fa fa-crown fa-2x text-warning mb-2" }, null, -1)),
                            _cache[35] || (_cache[35] = _createElementVNode("h6", { class: "card-title" }, "Subscription Plan", -1)),
                            _createElementVNode("span", _hoisted_68, _toDisplayString(selectedUser.value.subscription_plan), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("div", _hoisted_70, [
                          _createElementVNode("div", _hoisted_71, [
                            _cache[36] || (_cache[36] = _createElementVNode("i", { class: "fa fa-briefcase fa-2x text-primary mb-2" }, null, -1)),
                            _cache[37] || (_cache[37] = _createElementVNode("h6", { class: "card-title" }, "Workspaces Created", -1)),
                            _createElementVNode("h4", _hoisted_72, _toDisplayString(selectedUser.value.workspaces_created), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("div", _hoisted_74, [
                          _createElementVNode("div", _hoisted_75, [
                            _cache[38] || (_cache[38] = _createElementVNode("i", { class: "fa fa-users fa-2x text-success mb-2" }, null, -1)),
                            _cache[39] || (_cache[39] = _createElementVNode("h6", { class: "card-title" }, "Team Members", -1)),
                            _createElementVNode("h4", _hoisted_76, _toDisplayString(selectedUser.value.team_members), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("div", _hoisted_78, [
                          _createElementVNode("div", _hoisted_79, [
                            _cache[40] || (_cache[40] = _createElementVNode("i", { class: "fa fa-code fa-2x text-info mb-2" }, null, -1)),
                            _cache[41] || (_cache[41] = _createElementVNode("h6", { class: "card-title" }, "Tokens Used", -1)),
                            _createElementVNode("h4", _hoisted_80, _toDisplayString(selectedUser.value.api_requests_used.toLocaleString()), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("div", _hoisted_82, [
                          _createElementVNode("div", _hoisted_83, [
                            _cache[42] || (_cache[42] = _createElementVNode("i", { class: "fa fa-hdd fa-2x text-secondary mb-2" }, null, -1)),
                            _cache[43] || (_cache[43] = _createElementVNode("h6", { class: "card-title" }, "Storage Used", -1)),
                            _createElementVNode("h4", _hoisted_84, _toDisplayString(selectedUser.value.storage_used_mb) + " MB ", 1),
                            _createElementVNode("small", _hoisted_85, " Total: " + _toDisplayString(selectedUser.value.storage_total_mb), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("div", _hoisted_87, [
                          _createElementVNode("div", _hoisted_88, [
                            _cache[44] || (_cache[44] = _createElementVNode("i", { class: "fa fa-cogs fa-2x text-warning mb-2" }, null, -1)),
                            _cache[45] || (_cache[45] = _createElementVNode("h6", { class: "card-title" }, "Workspace Variables", -1)),
                            _createElementVNode("h4", _hoisted_89, _toDisplayString(selectedUser.value.workspace_variables), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_90, [
                        _createElementVNode("div", _hoisted_91, [
                          _createElementVNode("div", _hoisted_92, [
                            _cache[46] || (_cache[46] = _createElementVNode("i", { class: "fa fa-stream fa-2x text-danger mb-2" }, null, -1)),
                            _cache[47] || (_cache[47] = _createElementVNode("h6", { class: "card-title" }, "Lane Variables", -1)),
                            _createElementVNode("h4", _hoisted_93, _toDisplayString(selectedUser.value.lane_variables), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_94, [
                        _createElementVNode("div", _hoisted_95, [
                          _createElementVNode("div", _hoisted_96, [
                            _cache[48] || (_cache[48] = _createElementVNode("i", { class: "fa fa-sticky-note fa-2x text-primary mb-2" }, null, -1)),
                            _cache[49] || (_cache[49] = _createElementVNode("h6", { class: "card-title" }, "Card Variables", -1)),
                            _createElementVNode("h4", _hoisted_97, _toDisplayString(selectedUser.value.card_variables), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_98, [
                        _createElementVNode("div", _hoisted_99, [
                          _createElementVNode("div", _hoisted_100, [
                            _cache[50] || (_cache[50] = _createElementVNode("i", { class: "fa fa-shield-alt fa-2x text-dark mb-2" }, null, -1)),
                            _cache[51] || (_cache[51] = _createElementVNode("h6", { class: "card-title" }, "Internal Status", -1)),
                            _createElementVNode("div", _hoisted_101, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input me-2",
                                type: "checkbox",
                                role: "switch",
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((selectedUser.value.is_internal) = $event)),
                                onChange: _cache[12] || (_cache[12] = ($event: any) => (handleToggleInternal(selectedUser.value))),
                                style: {"cursor":"pointer"},
                                id: "modalInternalSwitch"
                              }, null, 544), [
                                [_vModelCheckbox, selectedUser.value.is_internal]
                              ]),
                              _createElementVNode("label", _hoisted_102, _toDisplayString(selectedUser.value.is_internal ? 'Marked as Internal' : 'Marked as External'), 1)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: closeUserDetailsModal
                }, " Close ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})